function svcdReconvert(){ try{ if(window.bucksCC&&bucksCC.reConvert) bucksCC.reConvert(); }catch(e){} }
function myCartSection() {
    if($('#shopify-section-header').hasClass('shopify-section-header-sticky')){
      var header_height = $('#shopify-section-header').height();
    }else{
      var header_height = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height();
    }
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.wrapper-cart-drawer__footer').innerHeight();
    $('.wrapper-cart-drawer__items .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
}
// NOTE: 'scroll' intentionally removed — myCartSection() reads then writes layout,
// so firing it every scroll frame caused layout thrashing / desktop scroll jank.
// The cart drawer height only needs recalculating on load, resize, and drawer open.
$(window).on('load resize',function () {
    myCartSection();
});

function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) { destination.innerHTML = source.innerHTML; destination.classList.remove('svcd-loading'); svcdReconvert(); svcdRefreshCartPage(); }
    var svcdCountEl = html.querySelector('#cart-drawer .svcd-count');
    var cart_count = svcdCountEl ? (parseInt(svcdCountEl.textContent.replace(/\D/g, ''), 10) || 0) : 0;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;
      cartRemove.addEventListener('click',(evt) => removeItem(data_line, cartRemove.closest('.item-row')));
    });
    renderCartUpsells();
    renderEmptyPopular();
    
    document.querySelectorAll('.header__icon--cart').forEach(function(cartButton){
      if (cartButton.dataset.svCartBound) return; // load_cart() runs on every cart change — bind once
      cartButton.dataset.svCartBound = '1';
      cartButton.addEventListener('click',function(e){
        // If the mobile menu drawer is open, close it through its own summary so
        // the theme's close logic (incl. scroll lock release) runs — otherwise the
        // menu stays overlaid above the cart drawer and the screen looks frozen.
        var openMenu = document.querySelector('header-drawer details[open]');
        if (openMenu) {
          var summary = openMenu.querySelector('summary');
          if (summary) summary.click();
        }
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
        myCartSection(); // refresh drawer height on open (no longer maintained on scroll)
      });
    });
    window.addEventListener('resize', function(event){
      var docWidth = document.documentElement.clientWidth;      

      if(docWidth < 990) {
        var swiper = new Swiper(".mySwiper", {
          slidesPerView: 2,
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter');
      });
    });
    (function() {
      myCartSection();
      var countDiv = document.querySelector('.cart-count-bubble') ? document.querySelector('.cart-count-bubble').querySelectorAll('[aria-hidden]')[0] : undefined;
      var countDivDesktop = document.querySelector('.cart-count-bubble .visually-hidden');
      var totalCount = document.querySelector('.cart-total-count');
      if (countDivDesktop != undefined) {
        countDivDesktop.innerHTML = cart_count + (cart_count === 1 ? ' item' : ' items');
      }
      if (countDiv != undefined) countDiv.innerHTML = cart_count;
      if (cart_count === 0 && totalCount != undefined) totalCount.innerHTML = 0;
    })();
  });
}
load_cart();

// Mirror guard: opening the hamburger menu while the cart drawer is open must close the cart,
// otherwise both overlays stack and the page appears frozen.
document.addEventListener('click', function(e){
  if (e.target.closest && e.target.closest('header-drawer summary')) {
    document.body.classList.remove('open-drawer','open-search','open-sort','open-filter');
  }
});

function removeItem(data_line, row){
  // Optimistic UI: collapse the row immediately, sync with Shopify in the background
  if (row && !row.classList.contains('is-removing')) {
    row.style.height = row.offsetHeight + 'px';
    row.offsetHeight; // force reflow so the height transition runs
    row.classList.add('is-removing');
  }
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    // Sync failed: restore the row
    if (row) {
      row.classList.remove('is-removing');
      row.style.height = '';
    }
    console.error('Error:', error);
  });
}

function updateQuantity(data_index, data_qty) {
	
  var upId = data_index;
  var upQTY = data_qty;
  updateCartItem(upId, upQTY)	
  
  async function updateCartItem(id, qty) {
    const result = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        line: Number(id),
        quantity: Number(qty)
      })
    })
    .then((data) => {
      if(data.status === 200){
        load_cart();
        //console.log("Done");
      }else{
        console.log('Cart drawer quantity is not updated.');
      }
    });
  }
}

/* ===== Cart drawer v3: "Complete your loadout" upsell row ===== */
function svcdEscape(str) {
  return String(str).replace(/[&<>"']/g, function(c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
  });
}
function svcdCardHtml(item) {
  var img = item.img ? item.img.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_360x$1$3') : '';
  var price = (item.priceCents / 100).toFixed(2);
  var cmp = item.cmpCents ? (item.cmpCents / 100).toFixed(2) : null;
  return '<div class="svcd-upsell__card">' +
    '<a class="svcd-upsell__img" href="' + svcdEscape(item.url) + '">' + (img ? '<img src="' + svcdEscape(img) + '" alt="' + svcdEscape(item.title) + '" loading="lazy">' : '') + '</a>' +
    '<div class="svcd-upsell__info">' +
      '<a class="svcd-upsell__title" href="' + svcdEscape(item.url) + '">' + svcdEscape(item.title) + '</a>' +
      '<div class="svcd-upsell__pricerow">' +
        '<span class="svcd-upsell__price"><span class="money">$' + price + '</span>' + (cmp ? ' <s><span class="money">$' + cmp + '</span></s>' : '') + '</span>' +
        (item.variantId ? '<button type="button" class="svcd-upsell__addsq" aria-label="Add ' + svcdEscape(item.title) + ' to cart" onclick="this.classList.add(\'is-adding\');custom_addtocart(' + item.variantId + ')"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="12" y1="4.5" x2="12" y2="19.5"/><line x1="4.5" y1="12" x2="19.5" y2="12"/></svg></button>' : '') +
      '</div>' +
    '</div>' +
  '</div>';
}
function svcdScrollHint(rowId) {
  var row = document.getElementById(rowId);
  if (!row) return;
  var wrap = row.closest('.svcd-upsell, .svcd-empty-popular');
  if (!wrap) return;
  var back = false;
  function upd() {
    var noOverflow = row.scrollWidth <= row.clientWidth + 8;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    var atStart = row.scrollLeft <= 8;
    if (atEnd) back = true;
    else if (atStart) back = false;
    wrap.classList.toggle('svcd-back', back && !noOverflow);
    wrap.classList.toggle('svcd-no-overflow', noOverflow);
  }
  row.addEventListener('scroll', upd, { passive: true });
  var hint = wrap.querySelector('.svcd-scrollhint');
  if (hint) {
    hint.addEventListener('click', function() {
      row.scrollBy({ left: back ? -242 : 242, behavior: 'smooth' });
    });
  }
  row.addEventListener('wheel', function(e) {
    if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
    if (row.scrollWidth <= row.clientWidth + 8) return;
    var atStart = row.scrollLeft <= 0 && e.deltaY < 0;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2 && e.deltaY > 0;
    if (atStart || atEnd) return;
    e.preventDefault();
    row.scrollLeft += e.deltaY;
  }, { passive: false });
  upd();
}
function renderEmptyPopular() {
  var wrap = document.getElementById('svcd-empty-popular');
  var row = document.getElementById('svcd-popular-row');
  if (!wrap || !row) return;
  fetch(window.Shopify.routes.root + 'collections/top-sellers-usa/products.json?limit=8')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var items = [];
      (data.products || []).forEach(function(p) {
        var v = null;
        for (var i = 0; i < (p.variants || []).length; i++) {
          if (p.variants[i].available !== false) { v = p.variants[i]; break; }
        }
        if (!v) return;
        items.push({
          url: '/products/' + p.handle,
          title: p.title,
          img: (p.images && p.images[0] && p.images[0].src) || '',
          priceCents: Math.round(parseFloat(v.price) * 100),
          cmpCents: (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) ? Math.round(parseFloat(v.compare_at_price) * 100) : null,
          variantId: v.id
        });
      });
      items = items.slice(0, 6);
      if (!items.length) { wrap.hidden = true; return; }
      row.innerHTML = items.map(svcdCardHtml).join('');
      svcdReconvert();
      wrap.hidden = false;
      svcdScrollHint('svcd-popular-row');
    })
    .catch(function(error) { console.log(error); });
}
function renderCartUpsells() {
  var wrap = document.getElementById('svcd-upsell');
  var row = document.getElementById('svcd-upsell-row');
  if (!wrap || !row) return;
  var inCart = Array.prototype.map.call(
    document.querySelectorAll('.wrapper-cart__item[data-product-id]'),
    function(el) { return el.dataset.productId; }
  );
  if (!inCart.length) { wrap.hidden = true; return; }
  var seed = inCart[0];
  function svcdFilter(prods) {
    var SVCD_UPSELL_MIN_CENTS = 2000;
    return prods.filter(function(p) {
      return p.available && p.price >= SVCD_UPSELL_MIN_CENTS && inCart.indexOf(String(p.id)) === -1;
    });
  }
  function fetchRecs(intent) {
    return fetch(window.Shopify.routes.root + 'recommendations/products.json?product_id=' + seed + '&limit=8&intent=' + intent)
      .then(function(r) { return r.json(); })
      .then(function(data) { return data.products || []; })
      .catch(function() { return []; });
  }
  if (!window.svcdRecsCache) window.svcdRecsCache = {};
  if (!window.svcdRecsCache[seed]) {
    window.svcdRecsCache[seed] = fetchRecs('related');
  }
  window.svcdRecsCache[seed]
    .then(function(prods) {
      prods = svcdFilter(prods).slice(0, 4);
      if (!prods.length) { wrap.hidden = true; return; }
      row.innerHTML = prods.map(function(p) {
        var v = null;
        for (var i = 0; i < (p.variants || []).length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        return svcdCardHtml({
          url: p.url,
          title: p.title,
          img: p.featured_image || '',
          priceCents: p.price,
          cmpCents: (p.compare_at_price && p.compare_at_price > p.price) ? p.compare_at_price : null,
          variantId: v ? v.id : null
        });
      }).join('');
      svcdReconvert();
      wrap.hidden = false;
      svcdScrollHint('svcd-upsell-row');
      myCartSection();
    })
    .catch(function(error) { console.log(error); });
}

function custom_addtocart(variantsId) {
  
  //console.log("Clicked");
	//console.log(variantsId);
  var pbTempId = Number(variantsId);
  var pbTempQTY = 1;
  var svcdBody = document.querySelector('body');
  svcdBody.classList.add('open-drawer');
  svcdBody.classList.remove('open-menu','open-search','open-sort','open-filter');
  var svcdSb = document.querySelector('.cart-sidebar');
  if (svcdSb) svcdSb.classList.add('svcd-loading');
  if (typeof myCartSection === 'function') myCartSection();
  addItem(pbTempId, pbTempQTY)

  async function addItem(variantId, quantity) {
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then((data) => {
      if(data.status === 200){  
        
        load_cart();
        svcdRefreshCartPage();
        //console.log("Done");
      }else{
        var sbErr = document.querySelector('.cart-sidebar');
        if (sbErr) sbErr.classList.remove('svcd-loading');
        console.log('cart-drawer error');
      }
    });
  }

}


/* USD-checkout micro-note: visible only when BUCKS shows a non-USD currency */
function svcdUsdNote() {
  function num(s) {
    s = String(s).replace(/[^0-9.,]/g, '');
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      s = (s.lastIndexOf('.') > s.lastIndexOf(',')) ? s.replace(/,/g, '') : s.replace(/\./g, '').replace(',', '.');
    } else if (s.indexOf(',') > -1) {
      s = (/,\d{2}$/.test(s)) ? s.replace(',', '.') : s.replace(/,/g, '');
    }
    return parseFloat(s);
  }
  var notes = document.querySelectorAll('.svcd-usd-note');
  Array.prototype.forEach.call(notes, function(note) {
    var ref = note.getAttribute('data-ref');
    var sub = ref ? document.querySelector(ref) : null;
    var disp = sub ? sub.textContent.trim() : '';
    var usd = (note.getAttribute('data-usd') || '').trim();
    var label = '';
    if (disp && usd && disp !== usd) {
      var codeM = disp.match(/\b([A-Z]{2,4})\b/);
      if (codeM && codeM[1] !== 'USD') {
        label = codeM[1];
      } else if (!codeM) {
        var a = num(disp), b = num(usd);
        if (isFinite(a) && isFinite(b) && Math.abs(a - b) > 0.005) {
          var symM = disp.match(/^[^\d\s]+/);
          var sym = symM ? symM[0] : '';
          label = (sym && sym.indexOf('$') === -1) ? sym : 'your currency';
        }
      }
    }
    var show = !!label;
    var c = note.querySelector('[data-usd-cur]');
    if (c && show && c.textContent !== label) c.textContent = label;
    if (note.hidden === show) note.hidden = !show;
  });
}
(function() {
  if (!window.MutationObserver) return;
  var t = null;
  var kick = function() { clearTimeout(t); t = setTimeout(svcdUsdNote, 150); };
  ['.cart-sidebar', '.cart__footer'].forEach(function(sel) {
    var target = document.querySelector(sel);
    if (target) new MutationObserver(kick).observe(target, { subtree: true, childList: true, characterData: true });
  });
  setTimeout(svcdUsdNote, 800);
  setTimeout(svcdUsdNote, 2000);
})();


/* refresh /cart page sections after drawer-side cart changes */
function svcdRefreshCartPage() {
  var stale = document.querySelectorAll('.shopify-section[id*="cart-items"], .shopify-section[id*="cart-footer"]');
  if (!stale.length) return;
  fetch(window.location.pathname)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      Array.prototype.forEach.call(stale, function(sec) {
        var fresh = doc.getElementById(sec.id);
        if (fresh) sec.innerHTML = fresh.innerHTML;
      });
      if (typeof svcdReconvert === 'function') svcdReconvert();
      svcdUsdNote();
    })
    .catch(function() {});
}
